/**
 * Applies a CSS variable theme given a valid JSON object.
 * Variables are applied to the <html> tag and can be viewed in its `style` attribute
 * @param theme
 */
export function applyTheme(theme: Record<any, any>) {
  const root = document.documentElement;

  Object.keys(theme).forEach((key) => {
    if (typeof theme[key] === 'string') {
      root.style.setProperty(key, theme[key]);
    } else {
      applyTheme(theme[key]);
    }
  });
}

interface Webfont {
  name: string;
  url: string;
  variants: string[];
  weights: { label: string; value: string }[];
  isDefault: boolean;
}
/**
 * Retrieves a set of webfonts given a valid `font_book` array.
 * Links are applied to the <head> tag
 * @param font_book
 */
export function applyFonts(font_book: Webfont[]) {
  font_book.forEach((font) => {
    const linkTag = document.createElement('link');

    linkTag.href = font.url;
    linkTag.rel = 'stylesheet';

    document.head.appendChild(linkTag);

    if (font.isDefault) {
      document.documentElement.style.setProperty(
        '--typeface-1-name',
        font.name,
      );
      document.documentElement.style.setProperty('--typeface--1', font.name);
    }
  });
}
